<template>
  <div class="baseContent-warp orderDetail-warp" v-loading="loading">
    <div class="orderDetail-title">
      <div class="title-left">
        <div @click="goBack" class="goBack"><i class="el-icon-arrow-left"></i>返回</div>
        <div>订单详情</div>
      </div>
      <div class="title-right">
        <div class="mr20">合计：¥{{ payment.realPay }}</div>
        <el-button class="print-btn" @click="toRefund" v-if="payment.realPay != refundPrice">退款</el-button>
        <el-button type="primary" @click="again">再来一单</el-button>
        <el-button @click="printTickt">打印小票</el-button>
      </div>
    </div>
    <div class="orderDetail-content">
      <div>门诊单号：{{ orderNumber }}</div>
      <!-- 费用明细 -->
      <div class="charge-info">
        <div class="display-f mb15">
          <div class="mr16">费用明细：总价¥{{ payment.totalPrice }}</div>
          <div class="mr16">实际付款：¥{{ payment.realPay }}</div>
          <div class="mr16">折扣比例：{{ payment.discount }}%</div>
          <div>折扣类型：{{ payment.discountType == '0' ? '整单折扣' : '药品折扣' }}</div>
        </div>
        <div class="display-f mb15" v-if="payList.length > 0">
          <div>付款明细：</div>
          <div class="mr10" v-for="item in payList" :key="item.id">{{ item.payWayStr }}：¥{{ item.payPrice }}({{
            item.payTime }})
          </div>
        </div>
        <div class="display-f" v-if="refundList.length > 0">
          <div>退款明细：</div>
          <div class="mr10" v-for="item in refundList" :key="item.id">{{ item.payWayStr }}：¥{{ item.refundAmount }}({{
            item.refundTime }}) </div>
        </div>
      </div>
      <!-- 患者、医生信息 -->
      <div class="patient-warp">
        <div class="patient-info">
          <div class="patient-name"><i class="el-input__icon el-icon-user-solid"></i>{{ patientInfo.patientName }}</div>
          <div class="patient-sex">{{ patientInfo.sex == '0' ? '男' : '女' }}</div>
          <div class="patient-age">{{ patientInfo.age }}岁 {{ patientInfo.ageMth }}月</div>
          <div class="patient-phone">{{ patientInfo.phone }}</div>
        </div>
        <div class="doctor-info">
          <div class="doctor-name">{{ doctorInfo.doctorName }}</div>
          <div class="register-price" v-if="editForm.registerPrice">¥{{ editForm.registerPrice }}</div>
        </div>
        <div class="salesPerson">{{ doctorInfo.salesPerson }}</div>
      </div>
      <!-- 加工配送信息 -->
      <div class="process-distribution-warp">
        <div class="title-warp">加工配送信息</div>
        <div class="process-distribution-content">
          <div class="process-warp" v-if="isProcessing">
            <div>加工信息：</div>
            <div class="process-right">
              <div v-for="(item, index) in orderRecipeDrug" :key="index">
                <div class="process-item" v-if="item.isProcessing == '1'">
                  <div class="mr40">中药处方{{ index + 1 }}</div>
                  <div class="mr40">加工方式：{{ item.processingWay }}</div>
                  <div class="mr40" v-if="item.processingWay == '熬药'">加工数量：每剂煎{{ item.bagNumber }}袋，共煎{{
                    item.bagNumberSum
                    }}袋
                  </div>
                  <div>加工费：¥{{ item.processingPrice }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="distribution-warp" v-if="isDelivery == '1'">
            <div class="mr12">配送信息：</div>
            <div class="mr40">收件信息：{{ orderDelivery.address }}</div>
            <div class="mr40">配送公司：{{ orderDelivery.companyName }}</div>
            <div class="mr40">运单单号：{{ orderDelivery.deliveryNumber }}</div>
            <div>运费：¥{{ orderDelivery.deliveryPrice }}</div>
          </div>
          <div class="invoice" v-if="isInvoice == '1'">开具发票</div>
        </div>
      </div>
      <!-- 处方信息 -->
      <div class="recipe-warp">
        <div class="title-warp">处方项目</div>
        <!-- 中药 -->
        <div class="drug-warp" v-if="orderRecipeDrug.length > 0">
          <div v-for="(item, index) in orderRecipeDrug" :key="index">
            <div class="drug-title">
              <div class="title-left">
                <img :src="imgArr.drugIcon" class="title-icon" />
                <div class="fw-500 ml10">中药处方{{ index + 1 }}</div>
                <div class="ml20">单号:{{ item.orderNumber }}</div>
                <div class="ml20">处方类型：{{ item.doseType | filterDoseType }}</div>
                <el-popover
                  v-if="judgeExplain(item.drugMethod, item.dose, item.frequency, item.takingDosage, item.remark)"
                  class="drug-explain" placement="top-start" width="250" trigger="hover"
                  :content="`${item.drugMethod},${item.dose},${item.frequency},${item.takingDosage},${item.remark}`">
                  <div slot="reference" class="drug-explain">
                    <img :src="imgArr.explainIcon" class="explain-icon">
                    <div>服药说明</div>
                  </div>
                </el-popover>
              </div>
              <div class="title-right">
                <div class="mr40">剂数：{{ item.doseNumber }}</div>
                <div class="mr40">总价：¥{{ formatTotalPrice(item.totalPrice, item.processingPrice) }}</div>
                <img :src="imgArr.printIcon" class="icon" @click="printPrescription(item.recipeDrugId, 1)">
              </div>
            </div>
            <customTable :tableData="item.recipeDrugItem" :column="drugColumn" :showPages="false"
              :header-cell-style="{ background: '#F5F9FF' }">
            </customTable>
          </div>
        </div>
        <!-- 隐秘 -->
        <div class="drug-warp" v-if="orderRecipeCombo.length > 0">
          <div v-for="(item, index) in orderRecipeCombo" :key="index">
            <div class="drug-title">
              <div class="title-left">
                <img :src="imgArr.comboIcon" class="title-icon" />
                <div class="fw-500 ml10">隐秘处方{{ index + 1 }}</div>
                <div class="ml20">单号:{{ item.orderNumber }}</div>
              </div>
              <div class="title-right">
                <div class="mr40">剂数：{{ item.doseNumber }}</div>
                <div class="mr40">总价：¥{{ item.totalPrice }}</div>
                <img :src="imgArr.printIcon" class="icon" @click="printPrescription(item.recipeComboId, 3)">
              </div>
            </div>
            <customTable :tableData="item.comboItems" :column="comboColumn" :showPages="false"
              :header-cell-style="{ background: '#F5F9FF' }">
            </customTable>
          </div>
        </div>
        <!-- 理疗 -->
        <div class="drug-warp" v-if="orderRecipePhysio.length > 0">
          <div v-for="(item, index) in orderRecipePhysio" :key="index">
            <div class="drug-title">
              <div class="title-left">
                <img :src="imgArr.phyIcon" class="title-icon" />
                <div class="fw-500 ml10">理疗处方{{ index + 1 }}</div>
                <div class="ml20">单号:{{ item.orderNumber }}</div>
              </div>
              <div class="title-right">
                <div class="mr40">总价：¥{{ item.totalPrice }}</div>
                <img :src="imgArr.printIcon" class="icon" @click="printPrescription(item.recipePhysioId, 2)">
              </div>
            </div>
            <customTable :tableData="item.recipePhysioItem" :column="physioColumn" :showPages="false"
              :header-cell-style="{ background: '#F5F9FF' }">
            </customTable>
          </div>
        </div>
      </div>
      <!-- 辅料 -->
      <!-- <div class="other-warp">
        <div class="title-warp">辅料</div>
        <div class="table-warp">
          <customTable :tableData="ingredientTable" :column="ingredientsColumn" :showPages="false"
            :header-cell-style="{ background: '#F5F9FF' }">
          </customTable>
        </div>
      </div> -->
      <!-- 物料 -->
      <div class="other-warp">
        <div class="title-warp">其他商品</div>
        <div class="table-warp">
          <customTable :tableData="materialTable" :column="materialColumn" :showPages="false"
            :header-cell-style="{ background: '#F5F9FF' }">
          </customTable>
        </div>
      </div>
      <!-- 备注 -->
      <div class="remark-warp">
        <div class="title-warp">备注</div>
        <div class="remark-content">
          <div class="remark-item">
            <div class="item-lebale">患者备注:</div>
            <div class="item-value">{{ patientRemark }}</div>
          </div>
          <div class="remark-item">
            <div class="item-lebale">医馆备注:</div>
            <div class="item-value">{{ deptRemark }} </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 打印 -->
    <printDialog v-if="printDialogShow" @printSuccess="printSuccess" @closePrintPrescription="closePrintPrescription"
      :id="printOrderId" :orderType="printOrderType" :printType="printType"></printDialog>
    <!-- 退款模态框 -->
    <PricingRefund v-if="dialogRefund" :orderNumber="ctOrderNumber" :orderId="orderId" :loading="loading"
      :dialogRefund="dialogRefund" @dialogRefundBack="dialogRefundBack" @loadingBack="loadingBack" />
  </div>
</template>
  
<script>
import customTable from '@/components/customTable/customTable.vue'
import { getOrderStaging, getPayRecord, getRefundRecord } from '@/api/pricingDetails'
import { isNull, debounce, deepClone, isEmptyArray, isNullObj, dictText } from '@/utils/validateBase'
import { PAY_WAY } from '@/utils/const'
import { Utils } from '@/utils/utils'
import printDialog from '@/components/printDialog.vue'
import PricingRefund from "@/components/Pricing/PricingRefund.vue"; // 退款组件
import { imgArr } from '@/assets/images/img'
export default {
  // 定义引入的组件
  components: { customTable, printDialog, PricingRefund },
  props: {},
  data() {
    return {
      imgArr: imgArr,
      drugColumn: [
        { label: "序号", type: "index" },
        { label: "药品名称", prop: "drugName" },
        { label: "药品类型", prop: "type" },
        { label: "生产厂家", prop: "manufacturer" },
        { label: "数量", prop: "number" },
        { label: "单价/元", prop: "price" },
        { label: "单位", prop: "unit" },
        { label: "小计/元", prop: "totalPrice" },
      ],//中药处方表头
      comboColumn: [
        { label: "序号", type: "index" },
        { label: "药品名称", prop: "comboItemName" },
        { label: "生产厂家", prop: "manufacturer" },
        { label: "数量", prop: "number" },
        { label: "单价/元", prop: "price" },
        { label: "单位", prop: "unit" },
        { label: "小计/元", prop: "totalPrice" },
      ],//隐秘处方表头
      physioColumn: [
        { label: "序号", type: "index" },
        { label: "理疗项目名称", prop: "physioName" },
        { label: "次数", prop: "number" },
        { label: "单价/元", prop: "price", },
        { label: "小计/元", prop: "totalPrice" },
      ],//理疗处方表头
      tableData: [{}],
      ingredientsColumn: [
        { label: "序号", type: "index" },
        { label: "辅料名称", prop: "ingredientsName" },
        { label: "数量", prop: "number" },
        { label: "单价/元", prop: "price" },
        { label: "单位", prop: "unit" },
        { label: "小计/元", prop: "totalPrice" },
      ],//辅料名称
      materialColumn: [
        { label: '序号', type: 'index' },
        { label: '物料名称', prop: 'drugName' },
        { label: '物料规格', prop: 'specifications' },
        { label: '单价/元', prop: 'price' },
        { label: '数量', prop: 'number' },
        { label: '单位', prop: 'unit' },
        { label: '小计/元', prop: 'totalPrice' },
      ],//辅料名称
      orderRecipeCombo: [],//隐秘处方
      orderRecipeDrug: [],//中药处方
      orderRecipePhysio: [],//理疗处方
      loading: false,//加载动画
      doctorInfo: {},//医生信息
      patientInfo: {},//患者信息
      editForm: {},//病例信息
      orderNumber: '',
      ctOrderNumber: '',//春堂订单编号
      ingredientTable: [],//辅料信息
      materialTable: [],//物料信息
      orderDelivery: {},//快递信息
      isDelivery: '',//是否配送
      isInvoice: '',//是否发票
      deptRemark: '',//医馆备注
      patientRemark: '',//患者备注
      payList: [],//支付记录
      payment: {},//支付信息
      isProcessing: false,//是否加工
      printDialogShow: false, // 打印模态框
      printOrderId: '',//打印订单id
      printOrderType: '',//订单类型 0挂号 1中药 2理疗 3隐秘 4划价单
      printType: '',//打印类型 1小票 2处方
      dialogRefund: false,//退款弹框
      refundList: [],//退款列表
      refundPrice: 0,//退款金额
    }
  },
  //变量监听
  watch: {},
  filters: {
    filterDoseType(val) {
      let str = ''
      if (val == 0) {
        str = '饮片'
      } else if (val == 1) {
        str = '颗粒'
      } else {
        str = '所有'
      }
      return str;
    }
  },
  computed: {
    formatTotalPrice() {
      let self = this;
      return function (totalPrice, processingPrice) {
        // 对计算属性进行传参
        if (totalPrice) {
          return self.$bigNumber(totalPrice, '-', processingPrice)
        }
      };
    },
    judgeExplain() {
      let self = this;
      return function (drugMethod, dose, frequency, takingDosage, remark) {
        // 对计算属性进行传参
        if (isNull(drugMethod) || isNull(dose) || isNull(frequency) || isNull(takingDosage) || isNull(remark)) {
          return false;
        } else {
          return true;
        }
      };
    },
  },
  // 页面初始化
  async created() {
    this.orderId = this.$route.query.orderId;
    await this.getOrderStaging()
  },
  // 页面DOM加载完成
  mounted() { },
  //离开页面时执行
  destroyed() { },
  // 页面方法
  methods: {
    /**
    * 获取划价单挂单详细信息
    */
    getOrderStaging() {
      this.orderRecipeCombo = [];
      this.orderRecipeDrug = [];
      this.orderRecipePhysio = [];
      return new Promise((resolve, reject) => {
        this.loading = true;
        getOrderStaging({ orderId: this.orderId }).then(async res => {
          let { code, data } = res
          if (code == 200) {
            this.loading = false
            if (!isNull(data)) {
              let { json, orderNumber, orderId } = data
              this.orderNumber = orderNumber;
              let orderObj = JSON.parse(json)
              console.log('json', orderObj);
              this.orderType = orderObj.orderType
              this.doctorInfo = orderObj.doctorInfo
              this.patientInfo = orderObj.patientInfo
              this.editForm = orderObj.editForm
              this.ctOrderNumber = orderObj.ctOrderNumber;
              this.ingredientTable = isNull(orderObj.ingredientsList) ? [] : orderObj.ingredientsList
              this.materialTable = isNull(orderObj.materialList) ? [] : orderObj.materialList
              this.orderDelivery = isNull(orderObj.orderDelivery) ? {} : orderObj.orderDelivery
              if (isNull(orderObj.payment)) {
                this.payment = {}
                this.isDelivery = '0'
                this.isInvoice = '0'
              } else {
                this.payment = orderObj.payment
                this.isDelivery = orderObj.payment.isDelivery
                this.isInvoice = orderObj.payment.isInvoice
                this.deptRemark = orderObj.payment.deptRemark
                this.patientRemark = orderObj.payment.patientRemark
              }
              if (Utils.gt(orderObj.orderRecipeDrug.length, 0)) {
                let index = orderObj.orderRecipeDrug.findIndex((item) => { return item.isProcessing == '1' })
                if (Utils.gt(index, -1)) this.isProcessing = true
              }
              this.orderRecipeDrug = orderObj.orderRecipeDrug
              this.orderRecipeCombo = orderObj.orderRecipeCombo
              this.orderRecipePhysio = orderObj.orderRecipePhysio
              this.getPayRecord()
              this.getRefundRecord()
              this.loading = false
            }
            resolve(data)
          } else {
            this.loading = false
          }
        })
      })
    },
    /**
    * 获取支付记录
    */
    getPayRecord() {
      if (isNull(this.ctOrderNumber)) return;
      return new Promise((resolve, reject) => {
        getPayRecord({ orderNumber: this.ctOrderNumber }).then(res => {
          if (res.code == 200) {
            let payList = []
            res.data.forEach(item => {
              PAY_WAY.forEach(obj => {
                if (item.payWay == obj.value) item.payWayStr = obj.label
              })
              if (item.paySuccess == '1') payList.push(item)
            })
            this.payList = payList
            resolve(res.data)
          }
        })
      })
    },
    /**
    * 处方打印
    */
    printPrescription(printOrderId, type) {
      this.printOrderId = printOrderId;
      this.printOrderType = type
      this.printType = '2'
      this.printDialogShow = true
    },
    /**
    * 取消打印
    */
    closePrintPrescription() {
      this.printDialogShow = false
    },
    /**
     * 打印完成
    */
    printSuccess() {
      this.printDialogShow = false;
    },
    /**
     * 打印小票
     */
    printTickt() {
      this.printOrderId = this.orderId;
      this.printOrderType = '4';
      this.printType = '1'
      this.printDialogShow = true
    },
    /**
   * 退款组件返回值 -- 退款模态框状态
   */
    dialogRefundBack(val) {
      this.dialogRefund = val
      this.getRefundRecord()
    },
    /**
   * 退款组件返回值 -- 页面加载状态
   */
    loadingBack(val) { this.loading = val },
    /**
     * 去退款
     */
    toRefund() {
      this.dialogRefund = true;
    },
    /**
     * 查询退款记录
     */
    getRefundRecord() {
      if (isNull(this.ctOrderNumber)) return;
      getRefundRecord({ orderNumber: this.ctOrderNumber }).then(res => {
        let { code, data } = res
        if (code == 200) {
          let arr = []
          let refundPrice = '0.00'
          data.forEach(item => {
            item.payWayStr = dictText(item.refundWay, PAY_WAY)
            if (item.refundSuccess == '1') {
              arr.push(item)
              refundPrice = this.$bigNumber(item.refundAmount, '+', refundPrice)
            }
          })
          this.refundList = arr
          this.refundPrice = refundPrice
        }
      })
    },
    /**
     * 返回
     */
    goBack() {
      this.$router.push('/pricing/orderlist')
    },
    /**
     * 再来一单
     */
    again() {
      this.$router.push(`/pricing/pricingdetails?page=again&patientId=${this.patientInfo.patientId}&doctorId=${this.doctorInfo.doctorId}&againId=${this.orderId}`)
    },
  },
}
</script>
<style lang="less" scoped>
.orderDetail-warp {
  background: #fff;
  width: 100%;
  height: 100%;
  border: 1px solid #EAEAEA;
  display: flex;
  flex-direction: column;
  overflow: auto;

  .orderDetail-title {
    padding: 26px 20px;
    color: #333;
    font-size: 18px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #F0F0F0;

    .title-left {
      display: flex;
      align-items: center;

      .goBack {
        font-size: 14px;
        color: #667182;
        margin-right: 12px;
        cursor: pointer;
      }
    }

    .title-right {
      display: flex;
      align-items: center;

      .print-btn {
        border: 1px solid #F54A45;
        color: #F63838;
      }
    }
  }

  .title-warp {
    font-size: 16px;
    font-weight: 500;
    padding: 12px 14px;
    border-bottom: 1px solid #E1E1E1;
    background: #EFF2F5;
  }

  .orderDetail-content {
    font-size: 14px;
    color: #333;
    font-weight: 400;
    padding: 20px;

    .charge-info {
      background: #F5FAFF;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #BDD4FC;
      padding: 20px 14px;
      margin-top: 12px;
    }

    .patient-warp {
      margin-top: 40px;
      display: flex;
      font-weight: 500;

      .patient-info {
        background: #FAFBFC;
        border: 1px solid #E1E1E1;
        border-radius: 4px;
        display: flex;

        .patient-name {
          padding: 2px 0;
          width: 118px;
          border-right: 1px dashed #D8D8D8;

          .el-icon-user-solid {
            color: #EA7F7F;
          }
        }

        .patient-sex {
          width: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px dashed #D8D8D8;
        }

        .patient-age {
          width: 140px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px dashed #D8D8D8;
        }

        .patient-phone {
          width: 130px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .doctor-info {
        margin-left: 20px;
        background: #FAFBFC;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #E1E1E1;
        display: flex;

        .doctor-name {
          width: 168px;
          display: flex;
          align-items: center;
          padding-left: 10px;
          box-sizing: border-box;
        }

        .register-price {
          border-left: 1px dashed #D8D8D8;
          width: 94px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding-right: 14px;
          box-sizing: border-box;
        }
      }

      .salesPerson {
        width: 171px;
        background: #FAFBFC;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #E1E1E1;
        display: flex;
        align-items: center;
        padding-left: 10px;
        box-sizing: border-box;
        margin-left: 20px;
      }
    }

    .process-distribution-warp {
      margin-top: 24px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #E1E1E1;

      .process-distribution-content {
        padding: 16px 14px;

        .process-warp {
          display: flex;
          padding-bottom: 24px;
          border-bottom: 1px solid #E1E1E1;

          .process-right {
            margin-left: 12px;

            .process-item {
              display: flex;
              margin-bottom: 16px;

              &:last-child {
                margin-bottom: 0;
              }
            }
          }
        }

        .distribution-warp {
          padding: 24px 0;
          border-bottom: 1px solid #E1E1E1;
          display: flex;
        }

        .invoice {
          padding-top: 24px;
        }
      }
    }

    .recipe-warp {
      border: 1px solid #E1E1E1;
      border-radius: 4px;
      margin-top: 36px;

      .drug-warp {
        margin-bottom: 28px;

        &:last-child {
          margin-bottom: 0;
        }

        .drug-title {
          padding: 18px 14px;
          box-sizing: border-box;
          border-top: 1px solid #E1E1E1;
          border-bottom: 1px solid #E1E1E1;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .title-left {
            display: flex;
            align-items: center;

            .title-icon {
              width: 24px;
              height: 24px;
              flex-grow: 0;
              flex-shrink: 0;
            }

            .drug-explain {
              display: flex;
              align-items: center;
              color: #333333;
              font-size: 14px;
              margin-left: 24px;

              .explain-icon {
                width: 24px;
                height: 24px;
                flex-grow: 0;
                flex-shrink: 0;
                margin-right: 4px;
              }
            }
          }

          .title-right {
            display: flex;
            align-items: center;
            font-weight: 500;

            .icon {
              width: 36px;
              height: 28px;
              margin-left: 14px;
            }
          }
        }
      }
    }

    .other-warp {
      margin-top: 36px;
      border: 1px solid #E1E1E1;
      border-radius: 4px;
      border-bottom: none;

      .table-warp {
        margin-top: 20px;
      }
    }

    .remark-warp {
      margin-top: 36px;
      border: 1px solid #E1E1E1;
      border-radius: 4px;

      .remark-content {
        padding: 20px 14px;
        box-sizing: border-box;

        .remark-item {
          display: flex;
          margin-bottom: 16px;
          line-height: 22px;

          .item-lebale {
            margin-right: 12px;
            flex-grow: 0;
            flex-shrink: 0;
          }
        }
      }
    }
  }
}
</style>